<template>
  <div class="leftCircle">
    <div id="circleChart">
      <PieChart id="patient_age_pie"
                :params="{'shengqu_name':'','diban_name':'','no_title':'','date_start':'2025-05-05','date_end':'2026-05-05'}"
                height="160px"
                color="#102122"
                width="372px"
                path="patient_age_pie"></PieChart>
    </div>

    <div class="precent flex-row-c-c">
      <div class="pre-item flex-row-c-c">
        <img class="icon" src="~@/assets/large/630@3x.png" alt=""/>
        <div class="dec flex-col-t">
          <span class="pre">{{ this.man_ratio }}</span>
          <span class="msg">男性占比</span>
        </div>
      </div>
      <div class="pre-item flex-row-c-c" style="margin-left: 50px">
        <img class="icon" src="~@/assets/large/632@3x.png" alt=""/>
        <div class="dec flex-col-t">
          <span class="pre">{{ this.woman_ratio }}</span>
          <span class="msg">女性占比</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from "@/views/charts/pie";

export default {
  name: "leftCircle",
  components: {
    PieChart
  },
  data() {
    return {
      man_ratio: 0,
      woman_ratio: 0,
    };
  },
  methods: {
    get_gender() {
      this.$http.post(process.env.VUE_APP_API_HOST + "/patient_gender_pie", {
        "extra_params": {
          "shengqu_name": "",
          "diban_name": "",
          "date_start": "2025-05-04 00:00:00",
          "date_end": "2026-05-04 23:59:59"
        }
      }).then((res) => {
        console.log("dddd" + res)
        var data_list = res['data']['data']
        var sum_of_genders = 0
        for (var data1 of data_list) {
          sum_of_genders += data1['value']
        }
        for (var data of data_list) {
          if (data['name'] == '男') {
            this.man_ratio = Math.round(100 * data['value'] / sum_of_genders, 4) + "%"
          }
          if (data['name'] == '女') {
            this.woman_ratio = Math.round(100 * data['value'] / sum_of_genders, 4) + "%"
          }
        }


      })
    }
  },
  mounted() {
    this.get_gender()
  },
};
</script>

<style scoped lang='scss'>
.leftCircle {
  width: 100%;
  height: 250px;
  color: rgb(185, 183, 183);
  padding: 10px 0;

  #circleChart {
    width: 495px;
    height: 160px;
    background: url("~@/assets/large/circle-bg.png");
    background-repeat: no-repeat;
    background-size: 30% 85%;
    background-position: center;
  }

  .precent {
    height: 80px;

    .icon {
      width: 42px;
      height: 42px;
    }

    .dec {
      margin-left: 5px;

      .pre {
        font-size: 18px;
      }

      .msg {
        font-size: 12px;
      }
    }
  }
}
</style>
